module.exports = __webpack_public_path__ + "static/img/about_us_bg.c5c46d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about_us_bg.png
// module id = lzj5
// module chunks = 0